document.addEventListener('DOMContentLoaded', function () {
    const swiperContainer = document.querySelector('.results-swiper');
    const swiperWrapper = document.querySelector(".swiper-wrapper");
    const slides = document.querySelectorAll(".swiper-slide");
    const nextBtn = document.querySelector('.swiper-btn-next');
    const prevBtn = document.querySelector('.swiper-btn-prev');
  
    const swiper = new Swiper('.results-swiper', {
        spaceBetween: 10,
        navigation: {
            nextEl: '.swiper-btn-next',
            prevEl: '.swiper-btn-prev',
        },
        breakpoints: {
            200: {
                slidesPerView: 1.38,
                spaceBetween: 15,
            },
            425:{
                slidesPerView: 2.3,
                spaceBetween: 15
            },
              768: {
                slidesPerView: 2.5,
                spaceBetween: 30,
            },
            990: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
             1024: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
        },
        on: {
            init() {
                setTimeout(checkNavigationVisibility, 0);
            },
            resize: checkNavigationVisibility,
            slideChange: checkNavigationVisibility
        }
    });
  
    function applyJustifyContent() {
        if (window.innerWidth >= 990) {
            swiperWrapper.style.justifyContent = slides.length > 3 ? "start" : "center";
        } else {
            swiperWrapper.style.justifyContent = "start";
        }
    }
  
    function checkNavigationVisibility() {
        const slidesPerView = swiper.params.slidesPerView === 'auto' 
            ? swiper.slides.length 
            : swiper.params.slidesPerView;
  
       
    }
  
    applyJustifyContent();
    setTimeout(checkNavigationVisibility, 0);
  
    window.addEventListener("resize", () => {
        applyJustifyContent();
        checkNavigationVisibility();
    });
  });
  